module.exports = __webpack_public_path__ + "img/AWITEL_Verbindung.71aef31c.svg";